import { defineMessages, useT } from "../i18n/index.ts";
import { Icon } from "../icons/Icon.tsx";

interface Props {
  title: string;
  cover?: string;
  /** Auteur, parution, éditeur… : seulement ce qui est connu. */
  details: Array<{ label: string; value: string }>;
  description?: string;
}

const messages = defineMessages({ cover: "Couverture de « {title} »" }, { cover: "Cover of “{title}”" });

/** La fiche du livre, ouverte depuis son titre en haut du lecteur (reprise de Studio). */
export function BookSheet({ title, cover, details, description }: Props) {
  const t = useT(messages);
  return (
    <div class="msb-book-sheet">
      <div class="msb-book-sheet__cover">{cover ? <img src={cover} alt={t("cover", { title })} /> : <Icon name="ebook" size={48} />}</div>
      <h3 class="msb-book-sheet__title">{title}</h3>
      {details.length > 0 && (
        <dl class="msb-book-sheet__details">
          {details.map((detail) => (
            <div key={detail.label}>
              <dt>{detail.label}</dt>
              <dd>{detail.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {description && <p class="msb-book-sheet__description">{description}</p>}
    </div>
  );
}
